import Vue from 'vue'
import titleHead from '@/components/titleHead/titleHead.vue'
Vue.component('title-head',titleHead)



// WEBPACK FOOTER //
// ./src/components/publicComponent.js